import React from 'react';
import styles from './styles.scss';

const SpaceNameAncestry: React.FunctionComponent<{id: string, name: string, ancestry: Array<string>}> = ({id, name, ancestry}) => (
  <div className={styles.spaceAncestry}>
    <span className={styles.spaceAncestryBreadcrumb}>
      {ancestry.join(' / ')}
    </span>
    {name}
  </div>
);

export default SpaceNameAncestry;
